import { t } from "i18next";

import { Label } from "../../../../../components/deprecated/Label/Label";
import { StatusTag } from "../../../../../components/deprecated/StatusTag/StatusTag";
import { Text } from "../../../../../components/deprecated/Text/Text";
import { RelativeData, RelativeDataType, RelativeHelper } from "../../../../../to-be-removed/LocalData/General/RelativeData";
import { V2CollectionItemData } from "../../../../../to-be-removed/LocalData/General/V2CollectionItemData";
import { PropertyCollectionData } from "../../../../../to-be-removed/LocalData/Property/Collections/PropertyCollectionData";
import styles from "./DeviationRelatives.module.css";
import { useEffect, useState } from "react";
import TypographyText from "@src/components/ui-components/TypographyText/TypographyText";
import { Spacer } from "@src/components/ui-components/Spacer/Spacer";

interface RelativesListProps {
  relatives: RelativeData[];
  className?: string;
}

export const RelativesList = (props: RelativesListProps) => {
  const [, setUpdate] = useState(new Date());

  // Load unloaded relatives
  useEffect(() => {
    props.relatives.forEach((relative) => {
      if (!relative.reference?.loaded) {
        relative.reference?.load().then(() => setUpdate(new Date()));
      }
    });
  }, [props.relatives]);

  return (
    <ul className={props.className}>
      {props.relatives.length === 0 ? (
        <Label text={t("main.noConnections")} type="paragraph" className={styles.italics} />
      ) : (
        props.relatives
          .sort((a, b) => a.name.localeCompare(b.name))
          .map((relative) => {
            const canView = RelativeHelper.canViewRelative(relative);
            let statusName =
              relative.type === RelativeDataType.DEVIATION
                ? t("main.deviation")
                : relative.type === RelativeDataType.ROUTINE
                  ? t("main.routine")
                  : relative.type === RelativeDataType.COLLECTION_ITEM
                    ? t("main.collection")
                    : relative.type === RelativeDataType.EXTERNAL
                      ? t("main.external")
                      : relative.type === RelativeDataType.SUBTASK
                        ? t("main.workTask")
                        : t("main.invalid");

            if (relative.reference?.parent instanceof PropertyCollectionData && relative.reference.parent.name.translate()) {
              statusName = relative.reference.parent.name.translate();
            } else if (relative.reference instanceof V2CollectionItemData && relative.reference.collection) {
              statusName = relative.reference.collection.name.translate();
            }
            const link = RelativeHelper.getRelativeLink(relative);

            return (
              <li key={relative.id + "-" + relative.name}>
                {link && canView ? (
                  <a href={link} target="_blank" rel="noopener noreferrer" style={{ textDecoration: "none" }}>
                    <div
                      style={{
                        boxSizing: "border-box",
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        width: "100%",
                        padding: "8px 0",
                        flexWrap: "wrap",
                        gap: 8,
                      }}
                    >
                      <TypographyText size="md" truncate={false}>
                        {relative.name}{" "}
                      </TypographyText>
                      <Spacer />
                      <StatusTag text={statusName} className={styles.rowTag} color="blue" />
                      <i className="material-icons">chevron_right</i>
                    </div>
                  </a>
                ) : (
                  <div
                    style={{
                      boxSizing: "border-box",
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      width: "100%",
                      padding: "8px 0",
                      flexWrap: "wrap",
                      gap: 8,
                    }}
                  >
                    <TypographyText size="md" truncate={false}>
                      {relative.name} {`(${t("main.not_accessible")})`}
                    </TypographyText>
                    <StatusTag text={statusName} className={styles.rowTag} color="blue" />
                  </div>
                )}
              </li>
            );
          })
      )}
    </ul>
  );
};
